module.exports = __webpack_public_path__ + "img/DE02777.f857e60c.png";